import { createFileRoute } from '@tanstack/react-router'
import DiligentEmployees from '@/features/diligent-employees'

export const Route = createFileRoute('/_authenticated/diligent-employees/')({
  component: DiligentEmployees,
}) 